// src/Home/Home.js
import React, { useRef, useEffect } from "react";
import Navbar from "./Navbar";
import StatCards from "./StatCard";

import OurBusiness from "./OurBusiness";
import LatestNews from "./LatestNews";
import ProjectSection from "./ProjectSection";

import Map from "./Map";

function Home() {
  const ourBusinessRef = useRef(null);
  const projectsRef = useRef(null);
  const newsRef = useRef(null);
  const partnersRef = useRef(null);
  const footerRef = useRef(null);
  const videoRef = useRef(null);

 
  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.play().catch((err) => {
        console.warn("Autoplay prevented:", err);
      });
    }
  }, []);

  return (
    <div style={{ overflowX: "hidden" }}>
     

      {/* Hero Video Section */}
      <div
        className="main"
        style={{
          position: "relative",
          height: "100dvh", // More accurate on mobile
          overflow: "hidden",
        
        }}
      >
        <video
          ref={videoRef}
          src={`${process.env.PUBLIC_URL}Video.mp4`}
          autoPlay
          loop
          muted
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
        
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.17)",
           
          }}
        ></div>
      </div>

      {/* Main Content */}
      <div style={{ padding: "5vw" }}>
        <StatCards />
      </div>

      <div ref={ourBusinessRef} style={{ scrollMarginTop: "80px" }}>
        <OurBusiness />
      </div>

      <div ref={projectsRef} style={{ scrollMarginTop: "80px" }}>
        <ProjectSection />
      </div>



      <div ref={newsRef} style={{ scrollMarginTop: "80px" }}>
        <LatestNews />
      </div>


      <div>
        <Map />
      </div>



    
    </div>
  );
}

export default Home;
